// Acha o tutorial da tela atual (PO1-3506): rota exata e, quando o tutorial
// mapeia abas, a aba da URL (`?aba=`). Função pura, sem React.
//
// Cada tutorial traz `telas: [{ rota, aba?, s }]`. Regras:
//   - a rota precisa casar exatamente com o pathname (com ou sem o prefixo /app);
//   - tela com `aba` só casa quando a URL tem `?aba=` igual;
//   - entre uma tela com a aba certa e outra sem aba na mesma rota, vence a
//     que tem a aba (é o capítulo mais específico);
//   - empate (dois tutoriais na mesma tela, como Integrações e os conectores):
//     vence a menor `ordem` do catálogo; os demais vão para `outros` (PO1-3738).
// Devolve { tutorial, inicioSegundos, tela, outros: [{ tutorial, inicioSegundos, tela }] } ou null.
//
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.

function normalizarRota(rota) {
  let r = String(rota || "").trim();
  if (!r) return "";
  const idx = r.indexOf("?");
  if (idx !== -1) r = r.slice(0, idx);
  if (r.length > 1 && r.charAt(r.length - 1) === "/") r = r.slice(0, -1);
  if (r.indexOf("/app/") !== 0 && r !== "/app") r = `/app${r.charAt(0) === "/" ? "" : "/"}${r}`;
  return r.toLowerCase();
}

export function abaDaBusca(search) {
  if (!search) return null;
  const q = new URLSearchParams(String(search));
  const aba = q.get("aba");
  return aba ? String(aba).trim().toLowerCase() : null;
}

function ordemDe(tutorial) {
  const n = Number(tutorial && tutorial.ordem);
  return Number.isFinite(n) ? n : Number.MAX_SAFE_INTEGER;
}

// a vem antes de b? Aba certa primeiro, depois a menor ordem, depois a posição na lista.
function antes(a, b) {
  if (a.peso !== b.peso) return a.peso > b.peso;
  if (ordemDe(a.tutorial) !== ordemDe(b.tutorial)) return ordemDe(a.tutorial) < ordemDe(b.tutorial);
  return a.posicao < b.posicao;
}

export default function tutorialDaTela(tutoriais, pathname, search) {
  const rotaAtual = normalizarRota(pathname);
  if (!rotaAtual) return null;
  const abaAtual = abaDaBusca(search);

  // Melhor tela de cada tutorial (um tutorial entra uma vez só).
  const porTutorial = [];
  (Array.isArray(tutoriais) ? tutoriais : []).forEach((tutorial, posicao) => {
    const telas = (tutorial && Array.isArray(tutorial.telas) && tutorial.telas) || [];
    let melhor = null;
    telas.forEach((tela) => {
      if (!tela || normalizarRota(tela.rota) !== rotaAtual) return;
      const abaTela = tela.aba ? String(tela.aba).trim().toLowerCase() : null;
      if (abaTela && abaTela !== abaAtual) return;
      const peso = abaTela ? 2 : 1;
      if (!melhor || peso > melhor.peso) {
        melhor = { peso, posicao, tutorial, tela, inicioSegundos: Math.max(0, Number(tela.s) || 0) };
      }
    });
    if (melhor) porTutorial.push(melhor);
  });

  if (!porTutorial.length) return null;
  const ordenados = porTutorial.slice().sort((a, b) => (antes(a, b) ? -1 : antes(b, a) ? 1 : 0));
  const saida = (m) => ({ tutorial: m.tutorial, tela: m.tela, inicioSegundos: m.inicioSegundos });
  const principal = ordenados[0];
  return { ...saida(principal), outros: ordenados.slice(1).map(saida) };
}
